export const DealerTypes = {
    NotHomologated: 1,
    Homologated: 2,
};



// WEBPACK FOOTER //
// ./src/constants/DealerTypes.js